export const TAKER_NAME_KEY = 'spectra_quiz_taker';
export const ADMIN_PASS_KEY = 'spectra_quiz_admin';

export function buildAttemptPayload(takerName, answersByQuestion) {
  return {
    taker_name: takerName,
    answers: Object.entries(answersByQuestion).map(([qid, ids]) => ({
      question_id: Number(qid),
      selected_option_ids: ids,
    })),
  };
}

export function isQuestionAnswered(question, selectedIds) {
  return Array.isArray(selectedIds) && selectedIds.length > 0;
}

export function toggleSelection(question, selectedIds, optionId) {
  const current = Array.isArray(selectedIds) ? selectedIds : [];
  if (question.type === 'multi') {
    return current.includes(optionId)
      ? current.filter((id) => id !== optionId)
      : [...current, optionId];
  }
  return [optionId];
}
